import routerOptions0 from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/nuxt-front-end-V2/nuxt-front-end/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}